document.addEventListener("DOMContentLoaded", () => {
  const menu = document.querySelector(".im-menu");
  menu?.addEventListener("click", () => document.querySelector(".im-links")?.classList.toggle("open"));

  const filter = (value) => {
    document.querySelectorAll("[data-card]").forEach((card) => {
      card.hidden = value !== "All" && card.dataset.card !== value;
    });
    document.querySelectorAll("[data-filter]").forEach((button) => button.classList.toggle("active", button.dataset.filter === value));
  };
  document.querySelectorAll("[data-filter]").forEach((button) => button.addEventListener("click", () => filter(button.dataset.filter)));
  document.querySelectorAll("[data-feeling]").forEach((button) => button.addEventListener("click", () => {
    filter(button.dataset.feeling);
    document.querySelector("#experiences")?.scrollIntoView({ behavior: "smooth" });
  }));

});
